import type { SxProps, Theme } from '@mui/material';

export const skillDetailClassNames = {
  pageRoot: 'skill-detail',
  page: 'skill-detail-page',
  body: 'skill-detail-body',
  stepList: 'skill-step-list',
  learningContent: 'skill-learning-content',
  applyPhase: 'skill-apply-phase',
  applyButton: 'skill-apply-button',
};

export const skillDetailStyles = {
  page: () =>
    ({
      display: 'flex',
      width: '100%',
      height: '100%',
      minWidth: 0,
      minHeight: 0,
      overflow: 'hidden',
      background: '#ffffff',
    }) as SxProps<Theme>,

  pageRoot: () =>
    ({
      display: 'grid',
      gridTemplateRows: 'minmax(0, 1fr)',
      width: '100%',
      height: '100%',
      minHeight: 0,
      maxHeight: '100%',
      overflow: 'hidden',
      borderRadius: 0,
      background: '#ffffff',
      boxShadow: 'none',
      '& button:focus-visible': {
        outline: '3px solid #098beb',
        outlineOffset: '2px',
      },
    }) as SxProps<Theme>,

  body: () =>
    ({
      display: 'grid',
      height: '100%',
      minHeight: 0,
      minWidth: 0,
      overflowX: 'hidden',
      overflowY: 'hidden',
    }) as SxProps<Theme>,

  stepList: (theme: Theme) =>
    ({
      display: 'grid',
      gridTemplateRows: 'minmax(0, 1fr) auto',
      alignContent: 'start',
      gap: 'clamp(12px, 2vh, 22px)',
      width: '100%',
      height: '100%',
      minHeight: 0,
      overflowY: 'hidden',
      padding: 'clamp(16px, 2.4vh, 26px) 0',
      background: 'linear-gradient(to right, transparent 0 calc(100% - 136px), #eeeeee calc(100% - 136px) 100%)',
      [theme.breakpoints.down(980)]: {
        background: 'linear-gradient(to right, transparent 0 calc(100% - 128px), #eeeeee calc(100% - 128px) 100%)',
      },
      [theme.breakpoints.down('sm')]: {
        padding: '20px 0 28px',
        background: 'none',
      },
    }) as SxProps<Theme>,

  learningContent: () =>
    ({
      display: 'grid',
      placeItems: 'center',
      containerType: 'size',
      width: '100%',
      height: '100%',
      minWidth: 0,
      minHeight: 0,
      maxHeight: '100%',
      overflow: 'hidden',
    }) as SxProps<Theme>,

  applyPhase: () =>
    ({
      display: 'grid',
      justifyItems: 'center',
      marginTop: '18px',
    }) as SxProps<Theme>,

  applyButton: () =>
    ({
      minHeight: '58px',
      display: 'inline-flex',
      alignItems: 'center',
      gap: '10px',
      border: 0,
      borderRadius: '7px',
      padding: '0 18px 0 14px',
      background: '#098beb',
      color: '#ffffff',
      fontSize: '18px',
      fontWeight: 400,
      cursor: 'pointer',
      textTransform: 'none',
      '&.MuiButton-root:hover': {
        background: '#098beb',
      },
      '&:disabled, &.MuiButton-root.Mui-disabled': {
        background: '#8fbfe5',
        color: '#ffffff',
        cursor: 'default',
      },
      '& .MuiButton-startIcon': {
        width: '38px',
        height: '38px',
        display: 'grid',
        placeItems: 'center',
        margin: 0,
        border: '3px solid #ffffff',
        borderRadius: '999px',
      },
      '& .MuiButton-startIcon .MuiSvgIcon-root, & .MuiButton-startIcon .skill-svg-icon': {
        width: '24px',
        height: '24px',
        fill: 'currentColor',
        stroke: 'none',
      },
    }) as SxProps<Theme>,

};
